import { createVerificationButtons } from '@/Containers/CrmSection/Components/VerificationButtons'
import { Hint } from '@/Ship/Components/Hint'

import { CLIENT_FIELD_LABELS } from '../Contracts/ClientFieldLabels'
import { CLIENT_REST_URL } from '../Contracts/IClient'

import type { CrmVerificationOwnerConfig } from '@/Containers/CrmSection/Components/VerificationButtons'

/**
 * Верифікація клієнта (`SPEC-009` §8.6): тексти — дослівно з легасі
 * (`uk.json`, §8.7), кнопки й модалки — спільні для власників CRM.
 */
export const CLIENT_VERIFICATION_CONFIG: CrmVerificationOwnerConfig = {
    restUrl: CLIENT_REST_URL,
    fieldLabels: CLIENT_FIELD_LABELS,
    forwarderResource: 'Setting.ListLegalEntity',
    texts: {
        verifyModalTitle: 'Верифікація клієнта',
        forwarderLabel: CLIENT_FIELD_LABELS.forwarder,
        blacklistConfirmTitle: 'Додати клієнта до чорного списку?',
        blacklistConfirmText:
            'Якщо клієнта верифіковано, відмітку «Ким верифіковано» й дату верифікації буде знято. ' +
            'Повернути клієнта можна кнопкою «З чорного списку» — після цього його доведеться верифікувати знову.',
        success: {
            send_to_verification: 'Клієнта успішно відправлено на верифікацію.',
            verify: 'Клієнта успішно верифіковано.',
            reject_verification: 'Верифікацію успішно відхилено.',
            blacklist: 'Клієнта успішно додано до чорного списку.',
            unblacklist: 'Клієнта успішно видалено з чорного списку.',
        },
    },
    verifyHint: (
        <Hint id="crm.client.verify-contract">
            Після підтвердження з'явиться договір із цим експедитором, номером і датою — на вкладці «Договори».
        </Hint>
    ),
}

/** Обробник `onButtons` картки клієнта в перегляді. */
export const ClientVerificationButtons = createVerificationButtons(CLIENT_VERIFICATION_CONFIG)
